import React, { useState, useContext } from 'react'
import styled, { css } from 'styled-components'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { ResetButton } from './ui'
import { COLORS, FONT_WEIGHTS } from '../globals/global.styles'
import { TranslationContext } from 'Src/context'
import { showConfirmationPopup } from 'Redux/app/app.actions'
import { connect } from 'react-redux'
import bedImage from '@/assets/images/bed.webp'

const Label = styled.label`
	font-size: 16px;
	font-weight: ${FONT_WEIGHTS.light};
	color: ${COLORS.text.secondary};
`

const ControlsGroup = styled.div``

const Button = styled(ResetButton)`
	${({ isDisabled }) => isDisabled
		&& css`
			cursor: default;

			> span > svg,
			> span > svg > path {
				color: ${COLORS.border.minor};
			}
		`}
`

const ValueContainer = styled.div`
	display: inline-block;
	width: 50px;
	text-align: center;
	font-weight: ${FONT_WEIGHTS.normal};
`

const PopupContainer = styled.div`
	margin: -16px;
`

const Image = styled.img`
	width: 100%;
`

const PopupBody = styled.div`
	padding: 16px;
`

function PopupContent() {
	const translation = useContext(TranslationContext)
	return (
		<PopupContainer>
			<Image
				src={bedImage}
				alt=""
			/>

			<PopupBody>
				<strong>
					{translation.t('Reduce number of guests?')}
				</strong>

				<p>
					{translation.t('We will prepare the room based on the number of guests to ensure everything is set up perfectly for your stay.')}
				</p>
			</PopupBody>

		</PopupContainer>
	)
}

const GuestAmountSelector = ({
	label,
	name,
	value: initialValue,
	minValue,
	maxValue,
	handleChange,
	showConfirmationPopup,
}) => {
	const translation = useContext(TranslationContext)
	const [value, setValue] = useState(initialValue || 0)

	const setValueAndHandleChange = (value) => {
		setValue(value)
		handleChange(value)
	}

	const onDecrease = (event) => {
		event.preventDefault()

		if (value <= minValue) {
			return
		}

		const newValue = Number(value) - 1

		showConfirmationPopup(
			PopupContent,
			() => {
				setValueAndHandleChange(newValue)
			},
			translation.t('Yes, reduce'),
			translation.t('Cancel'),
		)
	}

	const onIncrease = (ev) => {
		ev.preventDefault()
		if (value >= maxValue) return
		setValueAndHandleChange(Number(value) + 1)
	}

	return (
		<div>
			{label ? <Label htmlFor={name}>{label}</Label> : null}

			<ControlsGroup>
				<Button
					title={translation.t('Decrease number of guests')}
					type="button"
					isDisabled={value <= minValue}
					onClick={onDecrease}
				>
					<MinusCircleOutlined />
				</Button>
				<ValueContainer>{value}</ValueContainer>
				<Button
					title={translation.t('Increase number of guests')}
					type="button"
					isDisabled={value >= maxValue}
					onClick={onIncrease}
				>
					<PlusCircleOutlined />
				</Button>
			</ControlsGroup>

			<input id={name} hidden readOnly value={value} />
		</div>
	)
}

const mapDispatchToProps = (dispatch) => ({
	showConfirmationPopup: (text, onConfirm, confirmButtonText, cancelButtonText) => dispatch(
		showConfirmationPopup(text, onConfirm, null, confirmButtonText, cancelButtonText),
	),
})

export default connect(null, mapDispatchToProps)(GuestAmountSelector)
